import React,{useEffect,useState} from 'react';
import './../App.css';
import Hero from './../images/translogo.png';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
// import {Tooltip} from '@material-ui/core';
import { FaLinkedin, FaPhoneSquareAlt,FaRegEnvelope } from "react-icons/fa";
// import {BsFillEnvelopeFill ,BsTelephone} from "react-icons/bs";
import TypedText from "./TypedText";
import {Link} from 'react-router-dom'
// import SimplePopover from './3d/Popover';
import {Player} from '@lottiefiles/react-lottie-player';

export default function Header(){
    const [animationData, setAnimationData] = useState();
    useEffect(() => {
        import('./../images/18123-developer.json').then(setAnimationData);
    }, []);

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width:'100%',
      height:'100%',
      marginTop:'23vh'
    },
    paper: {
        background:'none',
        padding: theme.spacing(2),
        textAlign: 'center',
        boxShadow:'none'
    },
}));
  
    const classes = useStyles();
        return(
            <div className='container' >
                <Grid container spacing={3} >
                    <Grid  item  xs={12}>
                        <Paper className={classes.paper}>
                        <div className='logoConta'>
                                {/* <img src={Hero} alt='Mostafa abdelaziem Hero Logo'/> */}
                                <Player
                            className='proposal-body--left--lottie'
                                autoplay
                                loop
                                src={animationData}
                                style={{
                                height: '100%',
                                width: '100%'
                            }}></Player>
                        </div>
                        <TypedText textOne='Mostafa Abdelaziem' textTwo='Front-End Developer'/>
                        <div>
                        <div className="contact-home">
                            <div className="data">
                                <ul>
                                <li><a target={'_blank'} href="#"><FaRegEnvelope/> <span>Mostafa.abdo.ch12@gmail.com</span></a></li>
                                <li><a target={'_blank'} href="https://www.linkedin.com/in/mostafa-abdo-developer/"><FaLinkedin/> <span>mostafa-abdo-developer</span></a></li>
                                <li><a href="tel:+201126620207"><FaPhoneSquareAlt/> <span>+201126620207</span></a></li>
                                </ul>
                            </div>
                        </div>
                        {/* <ul className='contact_list'>
                            <li>
                                <a href="mailto: mostafa.abdo.ch12@gmail.com">Gmail</a>
                                </li>   
                            <li>
                                <a href='https://www.linkedin.com/in/mostafa-abdo-developer/'>LinkedIn</a>
                             </li>   
                            <li>
                                Phone Number : 01126620207
                            </li>
                        </ul> */}

                        <div className="center-element">
                            <a href='mailto:mostafa.abdo.ch12@gmail.com' target='_blank' className='see_projects'>
                                Contact Me
                            </a>
                            <a href='/Mostafa%20Abdelazeem%20-%20Front-End%20-%20Ui%20-%20Webflow%20Developer.pdf' 
                            download='Mostafa-Abdelazeem-Front-End-Ui-Webflow-Developer-Resume.pdf' 
                            class='see_projects'>
                            Download Resume
                            </a>

                            <Link to='/recentWorks' className='see_projects'>
                            Explore projects
                            </Link>
                        </div>

                          

                        </div>
                    
                        </Paper>
                    </Grid>

                </Grid>
            </div>
        )
}